// SPDX-License-Identifier: AGPL-3.0-or-later
import Authentication from '@app/features/auth/state/Authentication';
import Messages from '@app/features/messaging/state/Messages';
import {makeAutoObservable} from 'mobx';

interface MessageReplyState {
	messageId: string;
	mentioning: boolean;
}
class MessageReply {
	replyingMessageIds: Record<string, MessageReplyState> = {};
	highlightMessageId: string | null = null;
	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}
	isReplying(channelId: string, messageId: string): boolean {
		return this.replyingMessageIds[channelId]?.messageId === messageId;
	}
	isHighlight(messageId: string): boolean {
		return this.highlightMessageId === messageId;
	}
	startReply(channelId: string, messageId: string, mentioning: boolean): void {
		const message = Messages.getMessage(channelId, messageId);
		if (!message) {
			return;
		}
		const shouldMention = message.author.id === Authentication.currentUserId || message.webhookId ? false : mentioning;
		const current = this.replyingMessageIds[channelId];
		if (current && current.messageId === messageId && current.mentioning === shouldMention) {
			return;
		}
		this.replyingMessageIds[channelId] = {messageId, mentioning: shouldMention};
	}
	setMentioning(channelId: string, mentioning: boolean): void {
		const currentReply = this.replyingMessageIds[channelId];
		if (!currentReply || currentReply.mentioning === mentioning) {
			return;
		}
		currentReply.mentioning = mentioning;
	}
	stopReply(channelId: string): void {
		if (!(channelId in this.replyingMessageIds)) {
			return;
		}
		delete this.replyingMessageIds[channelId];
	}
	highlightMessage(messageId: string): void {
		this.highlightMessageId = messageId;
	}
	clearHighlight(): void {
		this.highlightMessageId = null;
	}
	getReplyingMessage(channelId: string): MessageReplyState | null {
		return this.replyingMessageIds[channelId] ?? null;
	}
}
export default new MessageReply();
